import { z } from "zod";
export const SuscribirPushSchema = z.object({
    endpoint: z.string().url(),
    keys: z.object({
        p256dh: z.string().min(1),
        auth: z.string().min(1),
    }),
});
export const DesuscribirPushSchema = z.object({
    endpoint: z.string().url(),
});
export const VapidPublicKeyRespuestaSchema = z.object({
    publicKey: z.string(),
});
//# sourceMappingURL=notificacion.schema.js.map